/** @jsxImportSource @emotion/react */
//import { css } from "@emotion/react"
import { ImmutableObject } from "@hookstate/core";
import clone from "clone";
import { useCheckoutFormState } from "../../../hooks/useCheckoutFormState";
import { Product } from "../../../hooks/useInventoryState";
import { useProductDetailsState } from "../../../hooks/useProductDetailsState";
import { useNavigate } from "react-router-dom";

export type ProductBrowserGridItemDescriptionProps = {
    product: ImmutableObject<Product>;
}
export const ProductBrowserGridItemDescription: React.FC<ProductBrowserGridItemDescriptionProps> = props => {
    const product = props.product;
    const productDetailsState = useProductDetailsState();
    const checkoutFormState = useCheckoutFormState();
    const warehouseId = checkoutFormState.get().warehouseIdValue;
    const locationId = checkoutFormState.get().locationIdValue;
    const fromDate = checkoutFormState.get().fromDateValue;
    const toDate = checkoutFormState.get().toDateValue;
    const navigate = useNavigate();

    return (<>
        <div
            className="field itemdescription"
            onClick={async () => {
                return Promise.resolve().then(async () => {
                    await productDetailsState.setProductAsync(clone(product) as Product);
                    navigate(`/product/${product.Id}/warehouseid/${warehouseId}/locationid/${locationId}/fromdate/${fromDate}/todate/${toDate}`);
                    //productDetailsState.setShowPopup(true);
                });
            }}
        >
            {product.ItemName}
        </div>
    </>);
}